import {
  XOA_HOP_DONG,
  XOA_HOP_DONG_SUCCESS,
  XOA_HOP_DONG_FAILURE,
  SHOW_XOA_HOP_DONG,
  CHECK_XOA_HOP_DONG,
  CHECK_XOA_HOP_DONG_SUCCESS,
  CHECK_XOA_HOP_DONG_FAILURE,
} from "./actionTypes";

export const xoaHopDong = (dataPost, callback) => ({
  type: XOA_HOP_DONG,
  dataPost,
  callback,
});

export const xoaHopDongSuccess = (data) => ({
  type: XOA_HOP_DONG_SUCCESS,
  payload: data,
});

export const xoaHopDongFailure = () => ({
  type: XOA_HOP_DONG_FAILURE,
});

export const showXoaHopDong = (dataPost) => ({
  type: SHOW_XOA_HOP_DONG,
  dataPost,
});

export const kiemTraXoaHopDong = (dataPost) => ({
  type: CHECK_XOA_HOP_DONG,
  dataPost,
});

export const kiemTraXoaHopDongSuccess = (data) => ({
  type: CHECK_XOA_HOP_DONG_SUCCESS,
  payload: data,
});

export const kiemTraXoaHopDongFailure = () => ({
  type: CHECK_XOA_HOP_DONG_FAILURE,
});
